export default __webpack_public_path__ + "static/media/0x3e121107f6f22da4911079845a470757af4e1a1b.0c693be9.png";